/* eslint-disable */
import * as Types from "./types";

import { TypedDocumentNode as DocumentNode } from "@graphql-typed-document-node/core";
export type GqlCustomisedContactDetailsQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type GqlCustomisedContactDetailsQuery = {
  __typename: "Query";
  customisedContactDetails: Array<{
    __typename: "CustomisedContactDetails";
    uri: string;
    operationId: string;
    teamUri: string;
    name: string;
    roleName: string;
    contactType: string;
    createdAt?: string | null;
    updatedAt?: string | null;
    deleted?: boolean | null;
    fields: Array<{
      __typename: "CustomisedContactDetailsField";
      fieldName: string;
      label: string;
    }>;
  }>;
};

export const CustomisedContactDetailsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "customisedContactDetails" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "customisedContactDetails" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "customisedContactDetailsFields",
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "customisedContactDetailsFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CustomisedContactDetails" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "uri" } },
          { kind: "Field", name: { kind: "Name", value: "operationId" } },
          { kind: "Field", name: { kind: "Name", value: "teamUri" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "roleName" } },
          { kind: "Field", name: { kind: "Name", value: "contactType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "fields" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "fieldName" } },
                { kind: "Field", name: { kind: "Name", value: "label" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "deleted" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GqlCustomisedContactDetailsQuery,
  GqlCustomisedContactDetailsQueryVariables
>;
